/*
 * @Author: your name
 * @Date: 2021-07-09 09:38:54
 * @LastEditTime: 2022-01-15 14:58:08
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: \contingency-manage\src\main.js
 */
import { createApp } from "vue";
import "default-passive-events"; // 添加事件管理者'passive'，来阻止'touchstart'事件，让页面更加流畅。 解决chrome下的warning问题
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import locale from "element-plus/es/locale/lang/zh-cn";
import "@/assets/style/iconfont/iconfont.css";

import "@/router/guard";

import directives from "@/directives/index.js";
import global from "@/components/global/index.js";
import detial from "@/components/formDetail/index.js";
import cpn from "@/components/compnment/index.js";
import drag from "v-drag";
// import "./mock/index";

import VueHtml2Canvas from "vue-html2canvas";
import socket from "@/plugins/socket.js";
import videoClient from "@/plugins/videoClient";
// 初始化主题，
import { initStyle } from "./hooks/useStyle";
import { QuillEditor } from "@vueup/vue-quill";
import "@vueup/vue-quill/dist/vue-quill.snow.css";
import "vue-cropper/dist/index.css";
import VueCropper from "vue-cropper";
initStyle();

const app = createApp(App);
app.use(drag);
app.use(VueHtml2Canvas);
app.component("QuillEditor", QuillEditor);
app.use(VueCropper);
app.use(socket);
app.use(videoClient);
app.use(store);
app.use(router);
app.use(ElementPlus, { locale });
global(app);
detial(app);
cpn(app);
directives(app);
app.mount("#app");
